import React, { useEffect, useMemo, useState } from 'react';
import video2 from './smoke2.mp4';
import './App.css';
import Card from './Card';
import Footer from './Footer';
import { processRecords } from './FileReader';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import './i18n';
import image1 from './slideshow/exterior1.jpg';
import image2 from './slideshow/exterior2.jpg';
import image3 from './slideshow/exterior3.jpg';
import image4 from './slideshow/exterior4.jpg';
import image6 from './slideshow/interior1.jpg';
import image7 from './slideshow/interior2.jpg';
import bgImage1 from './car2.jpg';
import { useSlideshow } from './Slideshow';

const SLIDESHOW_INTERVAL_MS = 9000;

function App() {
  const { t, i18n } = useTranslation();
  const [categorizedCards, setCategorizedCards] = useState({});
  const [activeCardIndex, setActiveCardIndex] = useState({});

  useEffect(() => {
    const records = t('records', { returnObjects: true });
    const processedRecords = processRecords(records);
    setCategorizedCards(processedRecords);
  }, [t]);

  const categories = useMemo(() => Object.keys(categorizedCards), [categorizedCards]);

  const currentImage = useSlideshow(
    [image1, image2, image3, image4, image6, image7],
    SLIDESHOW_INTERVAL_MS
  );

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'});
  };

  const handleSlideshowClick = () => {
    window.location.href = 'https://www.facebook.com/search/top?q=autodetailing.expert';
  };

  const mod = (n, m) => ((n % m) + m) % m;

  const handleNextCard = (category) => {
    setActiveCardIndex((prev) => {
      const cards = categorizedCards[category] || [];
      if (!cards.length) return prev;
      const current = prev[category] ?? 0;
      const next = (current + 1) % cards.length;
      return { ...prev, [category]: next };
    });
  };

  const handlePrevCard = (category) => {
    setActiveCardIndex((prev) => {
      const cards = categorizedCards[category] || [];
      if (!cards.length) return prev;
      const current = prev[category] ?? 0;
      const next = (current - 1 + cards.length) % cards.length;
      return { ...prev, [category]: next };
    });
  };

  return (
    <div className="App">
          <div className="background-layer" style={{
              backgroundImage: `url(${bgImage1})`
            }}>
            <video
              src={video2}
              autoPlay
              loop
              muted
              playsInline
              style={{ width: '100%', height: '100vh', objectFit: 'cover' }}
            />
          </div>
          <div className="title-card">
            <div className="lang_btn">
              <button onClick={() => i18n.changeLanguage('en')}>EN</button>
              <button onClick={() => i18n.changeLanguage('pl')}>PL</button>
              <button onClick={() => i18n.changeLanguage('es')}>ES</button>
            </div>
            <h1>{t('title')}</h1>
            <button onClick={scrollToBottom}>{t('book_button')}</button>
        </div>

          <div className="title-card">
          <h1>{t('page')}</h1>
          <img
            id="slideshow"
            key={currentImage}
            src={currentImage}
            alt="Slideshow"
            onClick={handleSlideshowClick}
          />
        </div>

      <div className="banner">
        <h1>{t('offers')}</h1>
      </div>

      <div className="maincontent">
      {categories.map((category) => {
        const cardsForCategory = categorizedCards[category] || [];
        if (!cardsForCategory.length) {
          return null;
        }

        const rawIndex = activeCardIndex[category] ?? 0;
        const safeIndex = mod(rawIndex, cardsForCategory.length);
        const card = cardsForCategory[safeIndex];

        return (
          <div key={category} className="category-container">
            <h2>{category}</h2>
            <div className="cards-row">
              <button
                type="button"
                className="card-nav card-nav-left"
                onClick={() => handlePrevCard(category)}
                aria-label={`Previous offer in ${category}`}
              >
                ‹
              </button>
              <Card
                key={`${category}-${safeIndex}`}
                title={card[0]}
                price={card[1]}
                description={card[2]}
                detailedDescription={<span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(card[3]) }} />}
                scrollToPage={scrollToBottom}
              />
              <button
                type="button"
                className="card-nav card-nav-right"
                onClick={() => handleNextCard(category)}
                aria-label={`Next offer in ${category}`}
              >
                ›
              </button>
            </div>
          </div>
        );
      })}
      </div>
      <Footer />
    </div>
  );
}

export default App;